"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
require("./Tooltip.css");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
/**
 * Tooltip Component
 *
 * This component creates a tooltip that appears when hovering over its children.
 * The tooltip uses absolute positioning to ensure it appears above other content.
 *
 * Tooltip and Children Dimensions:
 * ---------------------------------
 * |   width: x, height: y         |
 * |                               |
 * |         Children              |
 * |                               |
 * ---------------------------------
 * |   width: w, height: h         |
 * |                               |
 * |         Tooltip               |
 * |                               |
 * ---------------------------------
 *
 * Margin: m
 * Initial Position: Based on children's position relative to viewport
 *
 * Tooltip Positioning (relative to viewport):
 *
 * - Top:
 *   - top: childrenRect.y - tooltipHeight - margin
 *   - left: isMobile ? childrenRect.x : childrenRect.left + (childrenWidth / 2) - (tooltipWidth / 2)
 *
 * - Right:
 *   - top: isMobile ? childrenRect.y : childrenRect.top + (childrenHeight / 2) - (tooltipHeight / 2)
 *   - left: childrenRect.right + margin
 *
 * - Bottom:
 *   - top: childrenRect.y + childrenHeight + margin
 *   - left: isMobile ? childrenRect.x : childrenRect.left + (childrenWidth / 2) - (tooltipWidth / 2)
 *
 * - Left:
 *   - top: isMobile ? childrenRect.y : childrenRect.top + (childrenHeight / 2) - (tooltipHeight / 2)
 *   - left: childrenRect.left - tooltipWidth - margin
 *
 * The component adjusts the tooltip position if it would render off-screen.
 * It also updates the position on window resize and scroll events.
 * 
 * For mobile devices:
 * - Horizontal positioning (left/right) aligns with the start of the children element
 * - Vertical positioning (top/bottom) remains centered for left/right directions
 */

var TOOLTIP_MARGIN = 0;
var Tooltip = function Tooltip(props) {
  var _props$direction = props.direction,
    direction = _props$direction === void 0 ? "bottom" : _props$direction,
    content = props.content,
    children = props.children,
    _props$margin = props.margin,
    margin = _props$margin === void 0 ? TOOLTIP_MARGIN : _props$margin,
    _props$styleOverrides = props.styleOverrides,
    styleOverrides = _props$styleOverrides === void 0 ? {
      container: {},
      tip: {}
    } : _props$styleOverrides,
    _props$isMobile = props.isMobile,
    isMobile = _props$isMobile === void 0 ? false : _props$isMobile;
  var _useState = (0, _react.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    isTooltipVisible = _useState2[0],
    setIsTooltipVisible = _useState2[1];
  var _useState3 = (0, _react.useState)({}),
    _useState4 = _slicedToArray(_useState3, 2),
    tooltipStyles = _useState4[0],
    setTooltipStyles = _useState4[1];
  var tooltipRef = (0, _react.useRef)(null);
  var childrenRef = (0, _react.useRef)(null);
  var updatePosition = function updatePosition() {
    if (childrenRef.current && tooltipRef.current) {
      var childrenRect = childrenRef.current.getBoundingClientRect();
      var tooltipRect = tooltipRef.current.getBoundingClientRect();
      var top, left;
      var calculateForTop = function calculateForTop() {
        return {
          // center the tooltip horizontally on desktop
          // otherwise, place it at the start of the children
          top: childrenRect.y - margin - tooltipRect.height,
          left: isMobile ? childrenRect.x : childrenRect.left + childrenRect.width / 2 - tooltipRect.width / 2
        };
      };
      var calculateForRight = function calculateForRight() {
        return {
          // center the tooltip vertically on desktop
          // otherwise, place it at the start of the children
          top: isMobile ? childrenRect.y : childrenRect.top + childrenRect.height / 2 - tooltipRect.height / 2,
          left: childrenRect.right + margin
        };
      };
      var calculateForLeft = function calculateForLeft() {
        return {
          // center the tooltip vertically on desktop
          // otherwise, place it at the start of the children
          top: isMobile ? childrenRect.y : childrenRect.top + childrenRect.height / 2 - tooltipRect.height / 2,
          left: childrenRect.left - tooltipRect.width - margin
        };
      };
      var calculateForBottom = function calculateForBottom() {
        return {
          // center the tooltip horizontally on desktop
          // otherwise, place it at the start of the children
          top: childrenRect.y + childrenRect.height + margin,
          left: isMobile ? childrenRect.x : childrenRect.left + childrenRect.width / 2 - tooltipRect.width / 2
        };
      };
      switch (direction) {
        case "top":
          top = calculateForTop().top;
          left = calculateForTop().left;
          break;
        case "right":
          top = calculateForRight().top;
          left = calculateForRight().left;
          break;
        case "left":
          top = calculateForLeft().top;
          left = calculateForLeft().left;
          break;
        case "bottom":
        default:
          top = calculateForBottom().top;
          left = calculateForBottom().left;
          break;
      }

      // Adjust if tooltip goes off-screen
      if (left < 0) {
        // if tooltip goes off the left side of the viewport, place on right
        left = calculateForRight().left;
      }
      if (left + tooltipRect.width > window.innerWidth) {
        // if tooltip goes off the right side of the viewport, place on left
        left = calculateForLeft().left;
      }
      if (top < 0) {
        // if tooltip goes off the top side of the viewport, place on bottom
        top = calculateForBottom().top;
      }
      if (top + tooltipRect.height > window.innerHeight) {
        // if tooltip goes below the viewport, place on top
        top = calculateForTop().top;
      }
      setTooltipStyles({
        top: "".concat(top, "px"),
        left: "".concat(left, "px"),
        opacity: 1
      });
    }
  };
  (0, _react.useEffect)(function () {
    if (isTooltipVisible) {
      updatePosition();
      window.addEventListener("resize", updatePosition);
      window.addEventListener("scroll", updatePosition);
    }
    return function () {
      window.removeEventListener("resize", updatePosition);
      window.removeEventListener("scroll", updatePosition);
    };
  }, [isTooltipVisible]);
  var showTip = function showTip() {
    setIsTooltipVisible(true);
  };
  var hideTip = function hideTip() {
    setIsTooltipVisible(false);
  };
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "Tooltip-Wrapper",
    onMouseEnter: showTip,
    onMouseLeave: hideTip,
    style: styleOverrides.container
  }, /*#__PURE__*/_react["default"].createElement("div", {
    ref: childrenRef
  }, children), isTooltipVisible && /*#__PURE__*/_react["default"].createElement("div", {
    ref: tooltipRef,
    className: "Tooltip-Tip",
    style: _objectSpread(_objectSpread({}, styleOverrides.tip), tooltipStyles)
  }, content));
};
var _default = exports["default"] = Tooltip;